import { apiRequest } from "@/api";

const state = {
  config: undefined,
};

const mutations = {
  SET_OPEN_AI_CONFIG: (state, { data, rootState }) => {
    state.config = data?.openaiConfig || undefined;
    if (!state.config) return;
    //check for existing link
    const existingLink = rootState.app_drawer_links.find(
      (link) => link.to === "/LlmConfig"
    );
    if (existingLink) return;
    //add link to drawer
    rootState.app_drawer_links.push({
      to: "/LlmConfig",
      icon: "mdi-robot",
      text: "llm_config",
    });
    rootState.app_drawer_links.push({
      to: "/llmPlayground",
      icon: "mdi-face-agent",
      text: "llm_playground",
    });
  },
};

const actions = {
  FETCH_LLM_COLLECTIONS: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get(
          `llm_config/chroma/fetchCollections?database_name=${params.database_name}`
        )
        .then(({ data }) => {
          resolve(data.collections);
        })
        .catch((err) => {
          console.log("FETCH_LLM_COLLECTIONS", err);
          reject(err);
        });
    });
  },
  FETCH_OPEN_AI_MODELS: ({ commit }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("llm_config/openai/models")
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch((err) => {
          console.log("FETCH_OPEN_AI_MODELS", err);
          reject(err);
        });
    });
  },
  FETCH_AVAILABLE_LLM_MODELS: ({ commit }, endpoint) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get(`llm_config/chroma/get_available_llm_models?endpoint=${endpoint}`)
        .then(({ data }) => {
          resolve(data?.models || []);
        })
        .catch((err) => {
          console.log("FETCH_AVAILABLE_LLM_MODELS", err);
          reject(err);
        });
    });
  },
  FETCH_LLM_CONFIG: ({ commit, rootState }) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .get("llm_config/")
        .then(({ data }) => {
          commit("SET_OPEN_AI_CONFIG", { data, rootState });
          resolve(data);
        })
        .catch((err) => {
          console.log("FETCH_LLM_CONFIG", err);
          reject(err);
        });
    });
  },
  UPDATE_OPEN_AI_CONFIG: ({ commit, rootState }, payload) => {
    return apiRequest()
      .patch("llm_config/", payload)
      .then(({ data }) => {
        commit("SET_OPEN_AI_CONFIG", { data, rootState });
      })
      .catch((err) => {
        console.log("UPDATE_OPEN_AI_CONFIG", err);
      });
  },
  GENAI_PLAYGROUND_INVOKE: (state, params) => {
    return new Promise((resolve, reject) => {
      apiRequest()
        .post("admin/genai_playground", params)
        .then(({ data }) => {
          resolve({
            content: data?.content,
            logs: data?.logs,
            products: data?.products,
          });
        })
        .catch((e) => {
          reject(e);
        });
    });
  },
};

export default { state, mutations, actions };
